import { queryStudentSort } from 'api/queryFilters';
import xhr from 'xhr';
import xhrApi from 'xhr';

export default async function getPayments(data) {
  const response = await xhrApi(`/payments?filters[student][id][$eq]=${data.student}&pagination[limit]=-1`);

  return response.data.data;
}
